import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'

export interface ModalUserSearchInterface {
  onClickOk?: (userId: string) => void
  onClickCancel?: (updatedUserIds: string[]) => void
}

@Module({
  name: 'ModalUserSearchStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalUserSearchStore extends BaseStore {
  _isOpen: boolean = false

  _okCallback?: (userId: string) => void

  _cancelCallback?: (updatedUserIds: string[]) => void

  get isOpen(): boolean {
    return this._isOpen
  }

  @Mutation
  public open(params?: ModalUserSearchInterface) {
    this._isOpen = true
    this._okCallback = params?.onClickOk
    this._cancelCallback = params?.onClickCancel
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public ok(userId: string) {
    if (this._okCallback !== undefined) {
      this._okCallback(userId)
    }

    this._isOpen = false
  }

  @Mutation
  public cancel(updatedUserIds: string[]) {
    if (this._cancelCallback !== undefined) {
      this._cancelCallback(updatedUserIds)
    }

    this._isOpen = false
  }
}
